import React, { useState, useEffect } from "react";
import { RxCross2 } from "react-icons/rx";
import { IoMdArrowDropright } from "react-icons/io";
import { FaCaretRight, FaCheck } from "react-icons/fa";
import { Dropdown, DropdownItem } from "flowbite-react";
import { useSelector, useDispatch } from "react-redux";
import {
  getL2SheetProperty,
  updateLevel2Properties,
  setLevel2Properties,
  setCommonFilters,
} from "../../../WorkbookSlice";
import { BsCalendar2Date } from "react-icons/bs";
import {
  handleNumberObjectForQuickTable,
  handleQuickTable,
} from "../../../../smallFunction/SmallFunctions";
// Options for the dropdown items
const displayOptions = [
  { label: "Bar", value: "bar" },
  { label: "Line", value: "line" },
  { label: "Area", value: "area" },
];

const quickTableOptions = [
  { label: "Percentage Of Row Total", value: "percentageOfRowTotal" },
  {
    label: "Percentage Of Column Total",
    value: "percentageOfColumnTotal",
  },
  { label: "Percentage Of Grand Total", value: "percentageOfGrandTotal" },
  { label: "Runnig Total Across", value: "runningTotalAcross" },
  { label: "Runnig Total Down", value: "runningTotalDown" },
  { label: "Table Difference Across", value: "tableDifferenceAcross" },
  { label: "Table Difference Down", value: "tableDifferenceDown" },
  {
    label: "Table Difference Down In %",
    value: "tableDifferenceDownPercentage",
  },
  {
    label: "Table Difference Across In %",
    value: "tableDifferenceAcrossPercentage",
  },
  { label: "Clear Table Calculation", value: "clearTableCalculation" },
];

export default function DropDownComp1({
  handleDate,
  handleEdit,
  handleRemoveItem,
  data,
  viztype,
  reduxKey,
  dispatchCommonFilters,
  handleNumberFormat,
  handleGeogrophy,
  Sheetid,
  index,
  dispatchItemToredux,
  dispatchUpdateItem,
  dataSourceID,
}) {
  // console.log(data);
  // console.log(index);

  const [selectedDisplay, setSelectedDisplay] = useState("");
  const { visibleFilter = false, isCommonFilter = false } = data;
  const [localVisibleFilter, setLocalVisibleFilter] = useState(visibleFilter);
  const [commonFilterBoolean, setCommonFilterBoolean] =
    useState(isCommonFilter);

  // const [independentAxis, setIndependentAxis] = useState(false);
  const requiredArrayOfQuery = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "query", reduxKey)
  );
  const filterArray = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "query", "filters")
  );
  // console.log(requiredArrayOfQuery[0]);
  // console.log(commonFilterBoolean);

  const dispatch = useDispatch();

  const handleDisplayChange = (selectedValue) => {
    setSelectedDisplay(selectedValue);
    const updatedData = {
      ...data,
      display: selectedValue,
    };
    // console.log(updatedData);
    // Dispatch the action to update the level 2 properties with the transformed data
    dispatch(
      updateLevel2Properties({
        reduxKey: "valueColumns",
        Sheetid: Sheetid,
        parentKey: "query",
        value: updatedData,
        itemInArray: true,
        index,
      })
    );
  };

  const DropedDataType = data.dataType;
  const reduxQuickTableArray = useSelector((state) => {
    return getL2SheetProperty(state, Sheetid, "actions", "quickTable");
  });
  // console.log(reduxQuickTableArray);

  const quickItem =
    Array.isArray(reduxQuickTableArray) && reduxQuickTableArray.length
      ? reduxQuickTableArray.find((item) => item.nanoId === data.nanoId)
      : undefined;

  const [value, setValue] = useState(
    quickItem !== undefined ? quickItem.quickOption : ""
  );

  // Ensure that `quickArray` is always an array.
  const [quickArray, setQuickArray] = useState(
    Array.isArray(reduxQuickTableArray) && reduxQuickTableArray.length
      ? reduxQuickTableArray
      : []
  );

  const handleQuickTableCalculation = (option) => {
    const quickTableKey = `${data.measure.value}_${data.rename}`;
    // console.log(option);
    let updatedValueItem = null;
    if (
      [
        "percentageOfRowTotal",
        "percentageOfColumnTotal",
        "percentageOfGrandTotal",
        "tableDifferenceDownPercentage",
        "tableDifferenceAcrossPercentage",
      ].includes(option)
    ) {
      // console.log(`number for will update for ${option}`);
      // console.log(requiredArrayOfQuery[index]);

      updatedValueItem = {
        ...requiredArrayOfQuery[index],
        numberObject: {
          decimalPlaces: 1,
          factor: 0.01,
          prefix: "",
          sufix: "%",
          mode: "Manual",
        },
        index,
      };
    } else {
      // console.log(`number for will update for ${option}`);
      // console.log(requiredArrayOfQuery[index]);

      updatedValueItem = {
        ...requiredArrayOfQuery[index],
        numberObject: {
          decimalPlaces: 1,
          factor: 0.01,
          prefix: "",
          sufix: "%",
          mode: "Auto",
        },
        index,
      };
    }
    if (updatedValueItem) {
      handleNumberObjectForQuickTable(
        index,
        updatedValueItem,
        dispatch,
        updateLevel2Properties,
        Sheetid
      );
    }

    // Get previous quickArray value
    setQuickArray((prevQuickArray) => {
      const array = Array.isArray(prevQuickArray) ? prevQuickArray : [];

      // Find index of existing item
      const existingIndex = array.findIndex(
        (item) => item.nanoId === data.nanoId
      );

      let updatedArray;
      if (existingIndex !== -1) {
        // Update existing entry
        updatedArray = [...array];
        updatedArray[existingIndex] = {
          ...updatedArray[existingIndex],
          quickOption: option,
        };
      } else {
        // Add new entry
        updatedArray = [
          ...array,
          {
            nanoId: data.nanoId,
            quickTableKey: quickTableKey,
            quickOption: option,
          },
        ];
      }
      handleQuickTable(updatedArray, dispatch, updateLevel2Properties, Sheetid);
      return updatedArray;
    });

    setValue(option);
  };

  const handleIndependenceAxis = (index) => {
    if (requiredArrayOfQuery.length) {
      // Access the current independentAxis value and toggle it
      const currentAxis =
        requiredArrayOfQuery[index].independentAxis === undefined
          ? false
          : requiredArrayOfQuery[index].independentAxis;
      const updatedAxis = !currentAxis;

      // Log the current item for debugging
      // console.log(requiredArrayOfQuery[index]);

      // Create an updated item with the toggled independentAxis value
      const updatedItem = {
        ...requiredArrayOfQuery[index],
        independentAxis: updatedAxis,
      };

      // console.log(updatedItem);
      // Dispatch the update with the new independentAxis value
      dispatchUpdateItem(updatedItem, index);
    }
  };

  //horizontal line bar
  const handleHorizontalLineBar = (index) => {
    if (requiredArrayOfQuery.length) {
      // Access the current independentAxis value and toggle it
      const currentAxis =
        requiredArrayOfQuery[index].horizontalLineBar === undefined
          ? false
          : requiredArrayOfQuery[index].horizontalLineBar;
      const updatedAxis = !currentAxis;

      // Log the current item for debugging
      // console.log(requiredArrayOfQuery[index]);

      // Create an updated item with the toggled independentAxis value
      const updatedItem = {
        ...requiredArrayOfQuery[index],
        horizontalLineBar: updatedAxis,
      };
      // console.log(updatedItem);

      // Dispatch the update with the new independentAxis value
      dispatchUpdateItem(updatedItem, index);
    }
  };

  // Call useEffect to trigger updates when quickArray changes
  // useEffect(() => {
  //   if (quickArray.length) {
  //     handleQuickTable(quickArray, dispatch, updateLevel2Properties, Sheetid);
  //   }
  // }, [quickArray]);

  useEffect(() => {
    setLocalVisibleFilter(visibleFilter);
    setCommonFilterBoolean(isCommonFilter);
  }, [data, visibleFilter, isCommonFilter]);

  const toggleCommonFilter = () => {
    const newCommonFilterStatus = !commonFilterBoolean;
    // console.log(newCommonFilterStatus);
    setCommonFilterBoolean(!commonFilterBoolean);
    const updatedObject = { ...data, isCommonFilter: newCommonFilterStatus };
    // console.log(updatedObject);
    dispatch(
      setCommonFilters({
        operation: "UPDATE",
        value: updatedObject,
        Sheetid,
      })
    );
  };

  const toggleFilterVisibility = () => {
    const newVisibilityStatus = !localVisibleFilter;
    setLocalVisibleFilter(newVisibilityStatus);
    const updatedObject = {
      ...data,
      visibleFilter: newVisibilityStatus,
    };
    dispatchCommonFilters(updatedObject, "UPDATE");
  };

  const handleDiemension = (coordinateType) => {
    if (!coordinateType) return;

    let groupObject = { ...data, coordinateType };

    dispatchUpdateItem(groupObject, index);
  };
  // // console.log(data.dataType);

  return (
    <>
      <Dropdown
        label={<IoMdArrowDropright className="text-xl text-black" />}
        arrowIcon={false}
        dismissOnClick={false}
        placement="right-start"
        className="text-black flex items-center justify-centter  text-base font-UberMoveTextRegular w-auto ml-10 shadow-2xl"
        // style={{ padding: "1px" }}
      >
        {/* redux Key params */}
        {reduxKey === "filters" ? (
          <>
            <DropdownItem className="w-[97%] ">Filter...</DropdownItem>
            <hr className="border-b-0 border-gray-400 mx-2" />
            <DropdownItem
              className="w-[97%] flex items-center justify-start gap-2 pr-0"
              onClick={() => {
                toggleCommonFilter();
              }}
            >
              Apply On WorkSheets{" "}
              {commonFilterBoolean ? <FaCheck className="text-lg" /> : null}
            </DropdownItem>
            <DropdownItem
              className="w-[97%] flex items-center justify-start gap-2 pr-0 "
              onClick={() => {
                toggleFilterVisibility();
              }}
            >
              Show Filter {localVisibleFilter && <FaCheck />}
            </DropdownItem>
          </>
        ) : null}
        {viztype === "simpleTable" && reduxKey === "valueColumns" ? (
          <Dropdown
            label={
              <span className="w-[9.8rem] text-gray-600 flex items-center justify-start gap-2 pr-0">
                Quick table <FaCaretRight />
              </span>
            }
            placement="right-start"
            arrowIcon={false}
            className="flex items-start justify-left gap-2 text-base ml-4 pr-0 h-40 overflow-hidden overflow-y-auto"
            style={{
              margin: "2px 0px 5px 13px ",
            }}
          >
            {quickTableOptions.map((quickOption, index) => (
              <DropdownItem
                className={`${
                  value === quickOption.value ? "bg-gray-100" : ""
                }`}
                onClick={() => handleQuickTableCalculation(quickOption.value)}
              >
                {quickOption.label}
              </DropdownItem>
            ))}
          </Dropdown>
        ) : null}
        {reduxKey === "valueColumns" ? (
          <DropdownItem
            className="w-full"
            onClick={() => handleNumberFormat(data)}
          >
            Number Format
          </DropdownItem>
        ) : null}

        {reduxKey === "valueColumns" &&
        (viztype === "stackedbarchart" || viztype === "combochart") ? (
          <DropdownItem
            className="w-full gap-2"
            onClick={() =>
              requiredArrayOfQuery.length && handleIndependenceAxis(index)
            }
          >
            Independent Axis{" "}
            {requiredArrayOfQuery[index].independentAxis ? <FaCheck /> : null}
          </DropdownItem>
        ) : null}

        {/* horizontalline bar */}
        {reduxKey === "valueColumns" &&
        (viztype === "stackedbarchart" || viztype === "combochart") ? (
          <DropdownItem
            className="w-full gap-2"
            onClick={() =>
              requiredArrayOfQuery.length && handleHorizontalLineBar(index)
            }
          >
            Horizontal LineBar
            {requiredArrayOfQuery[index].horizontalLineBar ? <FaCheck /> : null}
          </DropdownItem>
        ) : null}

        {reduxKey === "tooltip" && (
          <DropdownItem
            className="w-[9.8rem] "
            onClick={() => handleNumberFormat(data)}
          >
            Number Format
          </DropdownItem>
        )}
        {reduxKey === "rows" ? null : data.dataType === "Date" ? null : (
          <DropdownItem
            className="w-[9.8rem] "
            onClick={() => handleEdit(data, index)}
          >
            Edit
          </DropdownItem>
        )}
        {/* Date Format */}
        {DropedDataType === "Date" &&
          ["rows", "groupByFields"].includes(reduxKey) && (
            <>
              <DropdownItem
                className="w-[9.8rem] "
                onClick={() => handleDate(data, index)}
              >
                Date format <BsCalendar2Date />
              </DropdownItem>
              <hr className="border-b-0 border-gray-400 mx-2" />
            </>
          )}
        {/* viz Type Params */}
        {viztype === "table" && (
          <Dropdown
            label={
              <span className="w-[9.8rem] text-gray-600 flex items-center justify-start gap-2 pr-0">
                Quick table <FaCaretRight />
              </span>
            }
            placement="right-start"
            arrowIcon={false}
            className="flex items-center justify-left gap-2 text-base ml-4 pr-0"
            style={{
              margin: "2px 0px 5px 13px ",
            }}
          >
            <DropdownItem
              className={`${
                value === "PercentageOfRowTotal" ? "bg-gray-100" : ""
              }`}
              onClick={() =>
                handleQuickTableCalculation("PercentageOfRowTotal")
              }
            >
              {" "}
              Percentage of row total
            </DropdownItem>
            <DropdownItem
              className={`${
                value === "PercentageOfColumnTotal" ? "bg-gray-100" : ""
              }`}
              onClick={() =>
                handleQuickTableCalculation("PercentageOfColumnTotal")
              }
            >
              {" "}
              Percentage of column total
            </DropdownItem>
            <DropdownItem
              className={`${
                value === "PercentageOfGrandTotal" ? "bg-gray-100" : ""
              }`}
              onClick={() =>
                handleQuickTableCalculation("PercentageOfGrandTotal")
              }
            >
              {" "}
              Percentage of grand total
            </DropdownItem>
            <DropdownItem
              className={`${value === "RunnigTotals" ? "bg-gray-100" : ""}`}
              onClick={() => handleQuickTableCalculation("RunnigTotals")}
            >
              {" "}
              Running totals
            </DropdownItem>
          </Dropdown>
        )}
        {reduxKey === "valueColumns" && viztype === "combochart" ? (
          <div>
            {
              <Dropdown
                key={"ab"}
                label={
                  <span className="w-[9rem] text-gray-600 flex items-center justify-start gap-2 pr-0">
                    Show as <FaCaretRight />
                  </span>
                }
                placement="right-start"
                arrowIcon={false}
                className="flex items-center justify-left  text-base pr-0"
                style={{ margin: "2px 0px 5px 13px" }}
              >
                {displayOptions.map((option) => (
                  <DropdownItem
                    key={option.value}
                    onClick={() => handleDisplayChange(option.value)}
                    className="flex items-center justify-between"
                  >
                    {option.label}
                    {selectedDisplay === option.value && (
                      <FaCheck className="text-gray-600 ml-2" />
                    )}
                  </DropdownItem>
                ))}
              </Dropdown>
            }
          </div>
        ) : null}
        {reduxKey === "groupByFields" && viztype === "areamap" && (
          <>
            <DropdownItem
              className="w-full"
              onClick={() => handleGeogrophy(data)}
            >
              Area Mapping
            </DropdownItem>
          </>
        )}
        {reduxKey === "groupByFields" && viztype === "cordinatemap" && (
          <Dropdown
            label={
              <span className="w-[9.8rem] text-gray-600 flex items-center justify-start gap-2 pr-0">
                Dimension Type
                <FaCaretRight />
              </span>
            }
            placement="right-start"
            arrowIcon={false}
            className="flex items-center justify-left gap-2 text-base ml-4 pr-0"
            style={{
              margin: "2px 0px 5px 13px",
              minWidth: "90px",
            }}
          >
            {data.dataType === "String" && (
              <DropdownItem className="w-[157px]">Area</DropdownItem>
            )}
            {data.dataType === "Number" ? (
              <>
                <DropdownItem
                  onClick={() => handleDiemension("latitude")}
                  className="w-[157px]"
                >
                  Latitude
                  {requiredArrayOfQuery[index].coordinateType === "latitude" ? (
                    <FaCheck className="text-gray-600 ml-2" />
                  ) : null}
                </DropdownItem>
                <DropdownItem
                  onClick={() => handleDiemension("longitude")}
                  className="w-[157px]"
                >
                  Longitude
                  {requiredArrayOfQuery[index].coordinateType ===
                  "longitude" ? (
                    <FaCheck className="text-gray-600 ml-2" />
                  ) : null}
                </DropdownItem>
              </>
            ) : null}
          </Dropdown>
        )}
        {/* common Params */}
        <DropdownItem
          className="flex items-center justify-left gap-1  w-[97%] pr-0"
          onClick={() => handleRemoveItem(data)}
        >
          Remove <RxCross2 className="text-black font-xl cursor-pointer" />
        </DropdownItem>
      </Dropdown>
    </>
  );
}
